const normalizeSlug = (slug = "") => {
  return String(slug)
    .trim()
    .replace(/\/+/g, "/")
    .replace(/^\/|\/$/g, "");
};

/**
 * Create product PDP URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getProductUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}/list?source=header&includeComingSoon=0`;
};

export const getQualityProductUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}/list?source=quality&includeComingSoon=0`;
};

/**
 * Create coming soon product URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getComingSoonProductUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}/list??source=header&comingsoon=1`;
};


/**
 * Create product Listing URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getlistingUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/${cleanSlug}`; 
};

/**
 * Create Home banner
 * Example:
 * /products/aquarius-214
 */

export const getHomeUrl = (url) => {
  if (!url) return "/";
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return `/${url.replace(/^\/+/, "")}`;
};


/**
 * Create product PDP URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getgridUrl = (slug) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}/grid`;
};


/**
 * Create product PDP URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getGridActionLink = (slug,source,includeComingSoon=0) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}/grid?source=${source}&includeComingSoon=${includeComingSoon}`;
};

/**
 * Create product PDP URL
 * Example:
 * /products/aquarius-214
 *
 * @param {string} slug
 * @returns {string}
 */
export const getListActionLink = (slug,source,includeComingSoon=0) => {
  const cleanSlug = normalizeSlug(slug);
  if (!cleanSlug) return "#";
  return `/products/${cleanSlug}/list?source=${source}&includeComingSoon=${includeComingSoon}`;
};


/**
 * Create checkout summary URL
 * Example:
 * /checkout/summary
 *
 * @returns {string}
 */
export const getCheckoutSummaryUrl = () => {
  return "/checkout/summary";
};
export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(blob);
  });
};

export const imageUrlToBase64 = async (imageUrl) => {
  if (!imageUrl) {
    throw new Error("Image URL is empty");
  }

  const response = await fetch(imageUrl, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
  });

  if (!response.ok) {
    throw new Error(
      `Image HTTP Error: ${response.status}`
    );
  }

  const blob = await response.blob();

  if (!blob || blob.size === 0) {
    throw new Error("Empty image blob");
  }

  return await blobToBase64(blob);
};
